import { useState, type ReactElement, type ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { InlineLink } from 'InlineLink';
import { type CurrentUser } from 'Users';
import { DeferralModal } from './DeferralModal';
import { LOCALE_PREFIX } from '../constants';

type SmallPrintProps = {
    currentUser: CurrentUser;
    // Selects the deferral modal copy that mentions the scholarship.
    hasScholarship: boolean;
};

// One line of the small print that sits below a registration card.
export function SmallPrintLine({ children }: { children: ReactNode }): ReactElement {
    return <p className="mb-0 text-center text-2xs text-slate-grey">{children}</p>;
}

// The deferral line below plan selection and full scholarship.
export function SmallPrint({ currentUser, hasScholarship }: SmallPrintProps): ReactElement {
    const { t } = useTranslation('back_royal');
    const [showDeferralModal, setShowDeferralModal] = useState(false);

    return (
        <>
            <SmallPrintLine>
                <Trans
                    t={t}
                    i18nKey={`${LOCALE_PREFIX}.smallprint`}
                    components={{
                        deferralLink: <InlineLink className="text-2xs" onPress={() => setShowDeferralModal(true)} />,
                    }}
                />
            </SmallPrintLine>

            {showDeferralModal ? (
                <DeferralModal
                    currentUser={currentUser}
                    hasScholarship={hasScholarship}
                    onClose={() => setShowDeferralModal(false)}
                />
            ) : null}
        </>
    );
}
